import { createNavigation } from "next-intl/navigation";
import { routing } from "./routing";
import { Metadata } from "next";

export const { Link, getPathname, redirect, usePathname, useRouter } =
  createNavigation(routing);

/**
 * Generates alternates metadata for a given URL.
 * For localized routes, generates locale-specific paths.
 * For non-localized routes, uses the same URL for all locales.
 *
 * @param url - The canonical URL path
 * @param options - Configuration options
 * @param options.isLocalized - Whether the route is localized (default: true)
 * @returns Metadata alternates object with canonical and languages
 */
export async function generateAlternates(
  url: string,
  options: { isLocalized?: boolean } = {},
): Promise<Metadata["alternates"]> {
  const { isLocalized = true } = options;

  const languages: Record<string, string> = {};

  for (const locale of routing.locales) {
    languages[locale] = isLocalized
      ? await getPathname({ locale, href: url })
      : url;
  }

  return {
    canonical: url,
    languages,
  };
}
